import get from 'lodash.get';

export default function findConnectedBoard(props) {
    const connectedBoard = get(props, 'userSocialNetwork.userPreferences.board');
    const board = get(props, 'userSocialNetwork.pinterest.boards', []).find(
        ({ url }) => url.indexOf(connectedBoard) > -1
    );

    if (!connectedBoard || !board) {
        return {
            connectedBoard: '',
            connectedBoardName: '',
        };
    }

    return {
        connectedBoard,
        connectedBoardName: board ? board.name : '',
    };
}



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/findConnectedBoard.es.js